import { render, staticRenderFns } from "./AudioLibrary.vue?vue&type=template&id=448160b9"
import script from "./AudioLibrary.vue?vue&type=script&lang=ts"
export * from "./AudioLibrary.vue?vue&type=script&lang=ts"
import style0 from "./audioLibrary.sass?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports